var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuterImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 123,
    viewBox: "0 0 176 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.26 28H46.69C49.1433 28 51.496 28.9746 53.2307 30.7093C54.9654 32.444 55.94 34.7968 55.94 37.25V103.9H28V37.25C28 36.0344 28.2396 34.8308 28.7051 33.7079C29.1706 32.585 29.8528 31.5648 30.7128 30.7057C31.5728 29.8467 32.5937 29.1655 33.7171 28.7012C34.8405 28.237 36.0444 27.9987 37.26 28Z",
    fill: "url(#paint0_linear_222_92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6899 38H88.1199C90.5732 38 92.926 38.9745 94.6607 40.7093C96.3954 42.444 97.3699 44.7967 97.3699 47.25V103.9H69.4399V47.25C69.4399 44.7967 70.4145 42.444 72.1492 40.7093C73.8839 38.9745 76.2367 38 78.6899 38Z",
    fill: "url(#paint1_linear_222_92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.25 5.4059e-06H133.68C134.896 -0.00130872 136.1 0.23698 137.223 0.701247C138.347 1.16552 139.367 1.84666 140.227 2.70573C141.087 3.5648 141.77 4.58496 142.235 5.70787C142.701 6.83079 142.94 8.03444 142.94 9.25001V105.91H115V9.25001C115 6.79675 115.975 4.44398 117.71 2.70927C119.444 0.974556 121.797 5.4059e-06 124.25 5.4059e-06Z",
    fill: "url(#paint2_linear_222_92)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_222_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.71 107.9H25.3501C24.8197 107.9 24.311 107.689 23.9359 107.314C23.5608 106.939 23.3501 106.43 23.3501 105.9C23.3501 105.369 23.5608 104.861 23.9359 104.486C24.311 104.111 24.8197 103.9 25.3501 103.9H149.71C150.241 103.9 150.749 104.111 151.124 104.486C151.499 104.861 151.71 105.369 151.71 105.9C151.71 106.43 151.499 106.939 151.124 107.314C150.749 107.689 150.241 107.9 149.71 107.9Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_222_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.35 117.27H49.7102C49.1798 117.27 48.6711 117.059 48.296 116.684C47.9209 116.309 47.7102 115.8 47.7102 115.27C47.7102 114.74 47.9209 114.231 48.296 113.856C48.6711 113.481 49.1798 113.27 49.7102 113.27H125.35C125.881 113.27 126.389 113.481 126.764 113.856C127.14 114.231 127.35 114.74 127.35 115.27C127.35 115.8 127.14 116.309 126.764 116.684C126.389 117.059 125.881 117.27 125.35 117.27Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_222_92)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_222_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 9,
    width: 168,
    height: 89
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.53 16.5899L142.3 9.78996C141.123 9.40154 139.88 9.25207 138.645 9.35036C137.409 9.44864 136.205 9.79267 135.104 10.3623C134.004 10.9319 133.027 11.7156 132.233 12.6675C131.439 13.6194 130.844 14.7202 130.481 15.9054C130.118 17.0906 129.995 18.3364 130.12 19.5696C130.245 20.8028 130.615 21.9987 131.208 23.0871C131.802 24.1754 132.606 25.1343 133.575 25.9075C134.544 26.6807 135.657 27.2528 136.85 27.5899L142.05 29.1799L81.2201 76.3899L47.1702 53.76C45.5745 52.7002 43.6907 52.1584 41.7759 52.2085C39.861 52.2587 38.0082 52.8982 36.4701 54.04L7.76015 75.35C5.77765 76.8219 4.46109 79.0211 4.10008 81.4638C3.73908 83.9064 4.36318 86.3925 5.83513 88.375C7.30708 90.3574 9.5063 91.674 11.949 92.035C14.3916 92.396 16.8776 91.7719 18.8601 90.2999L42.3101 72.8899L76.5301 95.59C78.1573 96.6654 80.0801 97.205 82.0293 97.1333C83.9784 97.0616 85.8564 96.3821 87.4001 95.19L152.44 44.59V49.3599C152.44 51.8291 153.421 54.1971 155.167 55.9431C156.913 57.6891 159.281 58.6699 161.75 58.6699C164.219 58.6699 166.587 57.6891 168.333 55.9431C170.079 54.1971 171.06 51.8291 171.06 49.3599V25.47C171.059 23.4874 170.425 21.5569 169.251 19.9597C168.076 18.3625 166.422 17.182 164.53 16.5899Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_222_92)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.97 -5.58008H-0.0598145V118.73H194.97V-5.58008Z",
    fill: "url(#paint3_linear_222_92)",
    fillOpacity: 0.5
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.53 10.3601C140.357 10.3605 141.179 10.4818 141.97 10.7201L164.19 17.5301C165.894 18.0445 167.387 19.095 168.446 20.5255C169.506 21.956 170.075 23.6901 170.07 25.4701V49.4001C170.07 51.604 169.195 53.7177 167.636 55.2762C166.078 56.8346 163.964 57.7101 161.76 57.7101C159.556 57.7101 157.443 56.8346 155.884 55.2762C154.326 53.7177 153.45 51.604 153.45 49.4001V44.5901C153.45 44.3249 153.345 44.0705 153.157 43.883C152.97 43.6955 152.715 43.5901 152.45 43.5901C152.229 43.5908 152.015 43.6646 151.84 43.8001L86.7501 94.3801C85.2881 95.5058 83.4953 96.1174 81.6501 96.1201C80.0132 96.1211 78.4126 95.6374 77.0501 94.7301L42.8801 72.0201C42.7146 71.9088 42.5196 71.8497 42.3201 71.8501C42.1062 71.8461 41.8976 71.9168 41.7301 72.0501L18.2701 89.4601C16.8433 90.5239 15.1098 91.0959 13.3301 91.0901C11.574 91.1051 9.85819 90.5633 8.42909 89.5425C6.99999 88.5217 5.93103 87.0744 5.37566 85.4082C4.82029 83.7421 4.80708 81.9429 5.33788 80.2688C5.86868 78.5947 6.9162 77.1318 8.33012 76.0901L37.0301 54.7801C38.4039 53.7589 40.0595 53.1868 41.7706 53.1421C43.4817 53.0974 45.1649 53.5821 46.5901 54.5301L80.5901 77.1701C80.7568 77.2778 80.9517 77.3335 81.1501 77.3301C81.3711 77.3294 81.5856 77.2556 81.7601 77.1201L142.55 29.8901C142.7 29.7753 142.814 29.6205 142.88 29.4435C142.945 29.2666 142.959 29.0747 142.92 28.8901C142.886 28.7111 142.804 28.5447 142.682 28.409C142.561 28.2733 142.404 28.1734 142.23 28.1201L137.02 26.5201C135.18 25.8831 133.623 24.6203 132.619 22.952C131.615 21.2837 131.229 19.316 131.527 17.392C131.826 15.4681 132.791 13.7102 134.254 12.425C135.716 11.1399 137.584 10.409 139.53 10.3601ZM139.53 9.36009C137.289 9.3446 135.117 10.1382 133.414 11.5951C131.711 13.052 130.59 15.0745 130.258 17.2911C129.927 19.5077 130.405 21.7696 131.607 23.6615C132.809 25.5534 134.653 26.9484 136.8 27.5901L142 29.1801L81.2201 76.3901L47.1702 53.7601C45.5755 52.6976 43.6913 52.1541 41.7758 52.2042C39.8602 52.2544 38.007 52.8956 36.4701 54.0401L7.76015 75.3501C5.77765 76.8221 4.46109 79.0212 4.10008 81.4639C3.73908 83.9066 4.36318 86.3926 5.83513 88.3751C7.30708 90.3576 9.5063 91.6742 11.949 92.0352C14.3916 92.3962 16.8776 91.772 18.8601 90.3001L42.3101 72.8901L76.5301 95.5901C78.1573 96.6655 80.0801 97.2052 82.0293 97.1334C83.9784 97.0617 85.8564 96.3822 87.4001 95.1901L152.44 44.5901V49.3601C152.44 51.8293 153.421 54.1973 155.167 55.9432C156.913 57.6892 159.281 58.6701 161.75 58.6701C164.219 58.6701 166.587 57.6892 168.333 55.9432C170.079 54.1973 171.06 51.8293 171.06 49.3601V25.4701C171.059 23.4875 170.425 21.5571 169.251 19.9599C168.076 18.3627 166.422 17.1821 164.53 16.5901L142.3 9.79011C141.416 9.51795 140.496 9.37975 139.57 9.38011L139.53 9.36009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_92",
    x: 19.3501,
    y: 100.9,
    width: 136.36,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_92",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_222_92",
    x: 43.7102,
    y: 110.27,
    width: 87.6399,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_92",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_222_92",
    x: 0,
    y: 6.32104,
    width: 175.06,
    height: 95.8186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_92",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_92",
    x1: 35.83,
    y1: 36.03,
    x2: 47.88,
    y2: 103.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_92",
    x1: 77.9599,
    y1: 44.91,
    x2: 88.4999,
    y2: 103.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_92",
    x1: 120.73,
    y1: 11.4,
    x2: 137.33,
    y2: 103.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_92",
    x1: 97.4552,
    y1: -5.58008,
    x2: 97.4552,
    y2: 118.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#8A4FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuterImg3);
export default __webpack_public_path__ + "static/media/futer_img3.f69e7b8726ed615aba74c7d59902c2c4.svg";
export { ForwardRef as ReactComponent };